import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useGlobalContext } from "../../utils/globalContext";
import { useMemo } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

const initializeContent = (content = []) => {
  if (content.length >= 2) return content;
  else return [content[0] || "", content[1] || ""];
};

export default ({ content: data }) => {
  const content = useMemo(() => initializeContent(data), [data]);
  const targetRef = useRef();
  const [tickerWidth, setTickerWidth] = useState(0);
  const [index, setIndex] = useState(0);
  const [move, setMove] = useState(false);
  const [partial, setPartial] = useState([content[0], content[1]]);
  const { Trans } = useGlobalContext();

  const scroll = isMounted => {
    return new Promise((resolve, reject) => {
      isMounted.value && setMove(true);
      setTimeout(() => {
        isMounted.value && setMove(false);
        resolve();
      }, 3000);
    });
  };

  useEffect(() => {
    const handleResize = () => setTickerWidth(targetRef.current.offsetWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useLayoutEffect(() => {
    if (targetRef.current) {
      setTickerWidth(targetRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    setPartial([content[index], content[(index + 1) % content.length]]);
  }, [index, content]);

  useEffect(() => {
    let isMounted = { value: true };
    const interval = setInterval(() => {
      scroll(isMounted).then(() => isMounted.value && setIndex((index + 1) % content.length));
    }, 6000);
    return () => {
      isMounted.value = false;
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [tickerWidth, content.length]);

  return (
    <div id="newsTicker">
      <div className="quoteLogo">
        <LazyLoadImage
          effect="blur"
          src="//public.speedoc.com/design/images/speedoc.com/icons/quotes.svg"
          alt="quotation mark"
          className="quotationMark"
        />
      </div>
      <div ref={targetRef} className="newsTickerInner">
        <div className={`slider ${move ? "fade" : ""}`}>
          {partial.map(({ title, image, small = true }, i) => {
            return (
              <div key={i} style={{ width: tickerWidth }} className="contentQuote">
                <LazyLoadImage alt="logo" src={image?.url} effect="blur" className={`logo ${small ? "small" : null}`} />
                <div className="text">
                  <Trans>
                    <p>{title}</p>
                  </Trans>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
